// Copyright (c) 2016 Deere & Company

import SearchFilters from '../../../shared/state/search-filters';

export const getDefaultState = () =>
    new SearchFilters({
        filterBy: '',
        query: '',
        sortBy: [],
        sortDirection: 'ASC'
    });

export default SearchFilters;



// WEBPACK FOOTER //
// ./src/product/shared/state/search-filters.js